// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { productGridCardStyles } from "@pace/Overrides/Widgets/ProductList/ProductListProductGridCard";
import { color, mergeWithCss, sharedBadgeStyle, xScreen } from "@pace/XDL/Utilities";
import { css } from "styled-components";

productGridCardStyles.productGridContainerStyles = {
    container: {
        css: css`
            border: 1px solid ${color("common.border")};
            border-radius: 4px;
            padding: 8px;
            max-width: 317px;
        `,
    },
    image: {
        css: css``,
    },
};

productGridCardStyles.productPriceAndActionsStyles = {
    productGridContainer: {
        container: {
            css: css`
                margin-top: auto;
                &.pricing-info-container {
                    margin-bottom: 12px;
                }
                &:empty {
                    display: none;
                }
            `,
        },
    },
};

productGridCardStyles.productListImageStyles = {
    wrapper: {
        css: css`
            position: relative;
        `,
    },
    compareCheckboxWrapper: {
        css: css`
            position: absolute;
            padding: 8px;
            background: ${color("common.white")};
            border-radius: 4px 0 4px 0;
            transform: translate(-8px, -8px);
            line-height: 1;
        `,
    },
    compareCheckbox: {
        css: css`
            margin: 0;
            padding: 0;
        `,
    },
    productAddToListStyles: {
        link: {
            typographyProps: {
                css: css`
                    display: none;
                `,
            },
            icon: {
                iconProps: {
                    size: 32,
                    css: css`
                        opacity: 1;
                        margin: 0;
                        background-color: ${color("common.ui1")};
                        border-radius: 32px;
                    `,
                },
            },
            css: css`
                position: absolute;
                bottom: 8px;
                right: 8px;
                &:hover {
                    ${IconWrapper} {
                        color: ${color("common.ui12")};
                    }
                }
            `,
        },
    },

    productImage: {
        linkWrappingImage: {
            css: css`
                position: relative;
                height: 301px;
                width: 100%;
            `,
        },
        img: {
            width: 301,
            height: 301,
            css: css`
                max-width: 100%;
                max-height: 100%;
                height: auto;
            `,
        },
    },
    badgeContainer: {
        ...mergeWithCss(sharedBadgeStyle.badge, {
            css: css`
                margin-top: 0;
                position: absolute;
                top: -8px;
                right: -8px;
                ${xScreen("gt", "xl")} {
                    max-width: 190px;
                    justify-content: flex-end;
                }
                & ${IconWrapper} {
                    opacity: 0.66;
                }
                & > div {
                    max-width: 101px;
                    border-radius: 0 4px;
                }
            `,
        }),
    },
};

productGridCardStyles.productInformationStyles = {
    container: {
        css: css`
            margin-bottom: 24px;
            margin-top: 8px;
        `,
    },
    attributes: {
        container: {
            gap: 5,
        },
    },
};
